import { Coppock as defaultOptions } from "./defaultOptionsForComputation";
import wma from "./wma";

/**
 * Coppock Curve Calculator
 *
 * Calculates the Coppock Curve oscillator.
 * Formula:
 * 1. ROC_short = 100 * (Close / Close[shortRoC] - 1)
 * 2. ROC_long = 100 * (Close / Close[longRoC] - 1)
 * 3. Sum = ROC_short + ROC_long
 * 4. Coppock = WMA(Sum, period)
 *
 * @returns {Function} Calculator function with options and undefinedLength methods
 */
export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, shortRoC, longRoC, sourcePath } = options;

    // Calculate the sum of two ROCs
    const sumData = data.map((d, i) => {
      if (i < longRoC) {
        return undefined;
      }

      const current = d[sourcePath];
      const shortAgo = data[i - shortRoC]
        ? data[i - shortRoC][sourcePath]
        : null;
      const longAgo = data[i - longRoC] ? data[i - longRoC][sourcePath] : null;

      if (
        !current ||
        !shortAgo ||
        !longAgo ||
        shortAgo === 0 ||
        longAgo === 0
      ) {
        return undefined;
      }

      // Sum = 100 * ((Close/Close[short]) + (Close/Close[long]) - 2)
      const sum = 100 * (current / shortAgo + current / longAgo - 2);
      return sum;
    });

    // Apply WMA to the sum
    const wmaCalculator = wma().options({
      windowSize: period,
      sourcePath: "value",
    });

    // Convert sumData to format expected by WMA calculator
    const wmaInput = sumData.map((value) => ({ value }));
    const coppockData = wmaCalculator(wmaInput);

    return coppockData;
  }

  calculator.undefinedLength = function () {
    const { period, longRoC } = options;
    return longRoC + period - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
